export default class LimeClaimTypes {
    static UserType: string = 'lime_usertype';
    static OrganisationUuid: string = 'lime_organisation_uuid';
    static OrganisationName: string = 'lime_organisation_name';
    static OrganisationUserType: string = 'lime_organisation_user_type';
    static Role: string = 'role';
}